<template>
  <div>
    <div class="table-responsive">
      <table
        class="table table-reports table-sm table-tp table-striped table-middle fs-sm mb-5"
      >
        <template v-for="item in data">
          <thead :key="'head-' + item.year">
            <tr>
              <th class="text-nowrap">
                <h5 class="d-inline-block font-weight-bolder mb-0">
                  {{ item.year }}
                </h5>
                <b-link
                  v-if="$root.user.isAdmin"
                  class="text-danger ml-1"
                  @click.prevent="remove(item.year)"
                >
                  <b-icon icon="trash" />
                  Vymazať
                </b-link>
              </th>
              <th
                v-for="(month, k) in $helpers.monthsSk()"
                :key="k"
                class="text-right bg-white"
              >
                {{ month }}
              </th>
            </tr>
          </thead>
          <tbody :key="'body' + item.year">
            <tr v-if="item.orderedDMM">
              <td class="text-nowrap font-weight-bold">
                <b-link
                  v-if="$root.user.isAdmin"
                  @click.prevent="edit(item.orderedDMM.id)"
                >
                  Dohodnutá DMM (m3)
                </b-link>
                <template v-else> Dohodnutá DMM (m3) </template>
              </td>
              <td
                v-for="(month, k) in $helpers.months()"
                :key="k"
                class="text-right"
              >
                <template v-if="item.orderedDMM[month]">
                  {{ item.orderedDMM[month] | formatNumber(2) }}
                </template>
                <template v-else> - </template>
              </td>
            </tr>
            <tr v-if="item.value">
              <td class="text-nowrap font-weight-bold">
                <b-link
                  v-if="$root.user.isAdmin"
                  @click.prevent="edit(item.value.id)"
                >
                  Max. Odber DMM (m3)
                </b-link>
                <template v-else> Max. Odber DMM (m3) </template>
              </td>
              <td
                v-for="(month, k) in $helpers.months()"
                :key="k"
                class="text-right"
              >
                <template v-if="item.value[month]">
                  {{ item.value[month] | formatNumber(2) }}
                </template>
                <template v-else> - </template>
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Rozdiel DMM (m3)</td>
              <template v-for="(month, k) in $helpers.months()">
                <td
                  v-if="
                    item.orderedDMM &&
                    item.orderedDMM[month] &&
                    item.value &&
                    item.value[month]
                  "
                  :key="k"
                  :class="{
                    'td-danger text-danger':
                      item.value[month] - item.orderedDMM[month] > 0,
                    'text-success':
                      item.value[month] - item.orderedDMM[month] < 0,
                  }"
                  class="text-right font-weight-bold"
                >
                  {{
                    (item.value[month] - item.orderedDMM[month])
                      | formatNumber(2)
                  }}
                </td>
                <td v-else :key="k" class="text-right">
                  <b-icon class="text-muted" icon="question-circle" />
                </td>
              </template>
            </tr>
            <tr>
              <td class="font-weight-bold">Nadlimit 105% - 110%</td>
              <td
                v-for="(month, k) in $helpers.months()"
                :key="k"
                class="text-right"
              >
                <template
                  v-if="item.maxOver105to110 && item.maxOver105to110[month]"
                >
                  {{ item.maxOver105to110[month] | formatNumber(2) }}
                </template>
                <template v-else> - </template>
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Nadlimit nad 110%</td>
              <td
                v-for="(month, k) in $helpers.months()"
                :key="k"
                class="text-right"
              >
                <template v-if="item.maxOver110 && item.maxOver110[month]">
                  {{ item.maxOver110[month] | formatNumber(2) }}
                </template>
                <template v-else> - </template>
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Suma nad limit (€ bez dph)</td>
              <td
                v-for="(month, k) in $helpers.months()"
                :key="k"
                class="text-right"
              >
                <vue-autonumeric
                  v-model="item.penalty[month]"
                  class="form-control form-control-sm text-right"
                  name="penalty"
                  placeholder="-"
                  style="position: relative; right: -6px"
                  @blur.native="
                    savePenalty(item.year, month, item.penalty[month])
                  "
                />
              </td>
            </tr>
          </tbody>
          <thead :key="'foot' + item.year">
            <tr>
              <td class="text-right pb-5" colspan="13">
                <b-badge
                  :variant="
                    totalPenalty[item.year] === 0 ? 'primary' : 'danger'
                  "
                  :class="{
                    'font-weight-normal': totalPenalty[item.year] === 0,
                    'font-weight-bold': totalPenalty[item.year] > 0,
                  }"
                  class="fs-base"
                >
                  Celková suma nad limit:
                  {{ totalPenalty[item.year] | formatNumber(2) }} € bez dph
                </b-badge>
              </td>
            </tr>
          </thead>
        </template>
        <thead v-if="data.length < total">
          <tr>
            <th class="text-center py-3 border-bottom-0" colspan="14">
              <b-btn @click="loadMore">
                <b-icon icon="plus-square" class="mr-1" />
                Načítať viac
                <b-badge variant="light" class="ml-1">
                  {{ total - data.length }}
                </b-badge>
              </b-btn>
            </th>
          </tr>
        </thead>
        <template v-if="lastYearsData[0] && lastYearsData[1]">
          <thead>
            <tr>
              <th class="text-center pb-0 border-bottom-0" colspan="14">
                <h5
                  class="d-inline-block bg-white font-weight-bolder px-3 py-2"
                >
                  Nárast / Pokles {{ lastYearsData[0].year }}/{{
                    lastYearsData[1].year
                  }}
                </h5>
              </th>
            </tr>
          </thead>
          <thead>
            <tr>
              <th class="font-weight-bold" />
              <th
                v-for="(month, k) in $helpers.monthsSk()"
                :key="k"
                class="font-weight-bold text-right bg-white"
              >
                {{ month }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td />
              <td
                v-for="(month, k) in $helpers.months()"
                v-if="
                  lastYearsData[0].value &&
                  lastYearsData[0].value[month] &&
                  lastYearsData[1].value &&
                  lastYearsData[1].value[month]
                "
                :key="k"
                class="text-right text-nowrap"
              >
                <b-icon
                  v-if="
                    lastYearsData[0].value[month] -
                      lastYearsData[1].value[month] >
                    0
                  "
                  class="text-danger"
                  icon="caret-up-fill"
                />
                <b-icon v-else class="text-success" icon="caret-down-fill" />
                {{
                  (lastYearsData[0].value[month] -
                    lastYearsData[1].value[month])
                    | formatNumber(2)
                }}
              </td>
              <td v-else class="text-right">
                <b-icon class="text-muted" icon="question-circle" />
              </td>
            </tr>
          </tbody>
        </template>
      </table>
    </div>
    <gas-chart ref="gasChart" :data="chartData" />
    <hr />
    <div class="mb-5">
      <h4>
        <b-icon icon="pencil" />
        Poznámky
        <transition name="fadeRightShort">
          <b-badge v-if="noteSaved" variant="primary">
            {{ noteSaved }}
          </b-badge>
        </transition>
      </h4>
      <b-form-textarea
        v-if="$root.user.isAdmin"
        v-model="note"
        placeholder="žiadne poznámky (kliknutím pridajte)"
        rows="4"
        @blur="$emit('onNoteChange', note)"
      />
      <div
        v-else
        class="h-auto form-control"
        v-html="note ? $options.filters.nl2br(note) : '-'"
      />
    </div>
  </div>
</template>
<script>
import GasChart from './Chart'
import collect from 'collect.js'

export default {
  components: { GasChart },
  props: ['data', 'note', 'total'],
  data() {
    return {
      noteSaved: null,
      penalty: {
        year: '',
        energetics_id: parseInt(this.$route.params.energetics_id),
      },
    }
  },
  computed: {
    chartData() {
      let output = []
      output = this.data.map((item) => {
        return {
          name: item.year,
          data: this.$moment
            .localeData('en')
            .months()
            .map((m) => {
              if (item.value) {
                return item.value[m.toLowerCase()]
              }
            }),
        }
      })
      return output
    },
    totalPenalty() {
      let output = {}
      this.data.forEach((item) => {
        let total = this.$moment
          .localeData('en')
          .months()
          .map((m) => {
            return item.penalty[m.toLowerCase()]
          })
        output[item.year] = total.reduce((a, b) => a + b, 0)
      })
      return output
    },
    lastYearsData() {
      let thisyear = this.$moment().year()
      return collect(this.data)
        .whereIn('year', [thisyear, thisyear - 1])
        .all()
    },
  },
  methods: {
    loadMore() {
      this.$emit('loadMore')
    },
    edit(id) {
      this.$root.$emit('reports.openPerformanceModal', { id: id })
    },
    remove(year) {
      this.$parent.$parent.remove(year)
    },
    savePenalty(year, month, value) {
      this.penalty.year = year
      this.$set(this.penalty, month, value)

      this.$api.post('reports/save_penalty', this.penalty).then(() => {
        this.penalty = {}
        this.penalty.year = ''
        this.penalty.energetics_id = parseInt(this.$route.params.energetics_id)
      })
    },
  },
}
</script>
